import { useEffect, useState } from "react";
import { HomeSections } from "@/components/storefront/HomeSections";
import { Seo } from "@/components/Seo";
import { usePageContent, useSite } from "@/context/SiteContext";
import { API } from "@/lib/api";

export default function Home() {
  const content = usePageContent("home");
  const { settings, categoryTree } = useSite();
  const [featured, setFeatured] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    API.get("/products", { params: { featured: true } }).then((r) => setFeatured(r.data.slice(0, 4))).catch(() => setFeatured([]));
    API.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
    API.get("/gallery").then((r) => setGallery(r.data)).catch(() => {});
  }, []);

  const business = settings?.business || {};
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Florist",
    name: business.name,
    telephone: business.phone,
    email: business.email || undefined,
    address: business.address,
  };

  const data = {
    settings,
    occasionsChildren: categoryTree.find((c) => c.slug === "occasions")?.children || [],
    featured,
    testimonials,
    gallery,
  };

  return (
    <div data-testid="home-page">
      <Seo title={content?.seo_title} description={content?.seo_description} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <HomeSections content={content} data={data} />
    </div>
  );
}
